angular.module('limousineModule').component('limousineItems', {
	templateUrl: 'limousineItems/limousineItems.html',
	bindings: {
		resultsItems: '<',
		redirectOnItemClick: '<',
		onSelectItem: '&'
	},
	controller: ['$http', function($http) {
		this.selectItem = function(item, $event) {
			$event && $event.preventDefault();
			this.onSelectItem({item: item});
		};
	}]
});
